import { useState } from "react";
import { api } from "../../../../../utility/api";

const ENDPOINT = "desfase_reloj";

// Relojes de producción y de bodega: el desfase vigente de cada uno, sus
// cambios y su historial
export const DesfaseRelojApi = () => {
    const [cargando, setCargando] = useState(false);

    const getRelojVigente = async (contexto) => {
        try {
            setCargando(true);
            const response = await api.get(`${ENDPOINT}/vigente`, { contexto });
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const registrarCambioReloj = async (data) => {
        try {
            setCargando(true);
            const response = await api.post(ENDPOINT, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getHistorialReloj = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(ENDPOINT, params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getRelojVigente,
        registrarCambioReloj,
        getHistorialReloj,

        cargando,
    };
};
